<div class="sidebar-skeleton-container d-flex flex-column align-items-center p-3">
    <div class="skeleton-logo mb-4 mt-1"></div>
  
    <div *ngFor="let icon of iconArray" class="skeleton-icon mb-3"></div>
  </div>
  